(function() {
'use strict';

    angular.module('GorillaBoy.DocumentViewer')
    .directive('feedbackSidebar', [
        '$log',
        '$rootScope',
        '$q',
        '$timeout',
        '$filter',
        'SignalProvider',
        'DocumentService',
        'DocumentStateService',
        'SourceConstant',
        'DocumentUtilities',
        'ClientMetricsService',
        'MetricEvents',
        'AppConstants', feedbackSidebarDirectiveFn]);
    function feedbackSidebarDirectiveFn($log, $rootScope, $q, $timeout, $filter, SignalProvider, DocumentService, DocumentStateService, SourceConstant, DocumentUtilities, ClientMetricsService, MetricEvents, AppConstants) {
        return {
            restrict: 'E',
            replace: false,
            priority: 5000,
            templateUrl: './document-viewer/feedback.html',
            link: function(scope, element, attrs) {
                scope.RightTabTypes = AppConstants.RightTabTypes;
                scope.isComment = DocumentUtilities.isComment;
                scope.isAnnotation = DocumentUtilities.isAnnotation;
                scope.isAnnotationInput = DocumentUtilities.isAnnotationInput;

                //Initilize the feedback loaded time for integration tests.
                $rootScope.feedbackLoadedTime = null;
            }
        };
    }
}());